exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku-select[data-v-3e314f81]  .el-form-item.is-error .el-input__inner{border-color:#dddfe7 !important}.sku-select .selWidth[data-v-3e314f81]{width:300px}", ""]);

// exports
